module.exports = __webpack_public_path__ + "static/media/file.edfa3af4.svg";